/**
 * --------------------------------------------------------------------------
 * Frontend template muenchen.de: log.js
 * Import a logger for easier debugging.
 * --------------------------------------------------------------------------
 */

import debug from 'debug';
import config from '../config/config';

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */
const DEBUG_NAMESPACE = `${config.debugNamespace}:log`;

/**
 * ------------------------------------------------------------------------
 * Enable the logger.
 * ------------------------------------------------------------------------
 */
if (process.env.NODE_ENV === config.envName.dev) {
  const log = debug(DEBUG_NAMESPACE);
  debug.enable('mde:*');
  log('Logging is enabled!');
} else {
  debug.disable();
}

